<div class="origin-manufacture-container"  *ngIf="!!selectedLanguage && selectedLanguage === 'fr'">
    <div class="origin-manufacture-flag">
        <div></div>
        <div></div>
        <div></div>
    </div>
    <div>
        <a href="{{ 'MADE_IN_FRANCE_LINK' | translate }}" [ngClass]="{'no-shadow': shadowEnabled !== true}" [ngStyle]="{'color': color}" target="_blank" (click)="$event.stopPropagation()">
            {{ 'MADE_IN_FRANCE_LABEL' | translate }}
        </a>
    </div>
</div>
